import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@ebootis/utilities';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AvailableConfigurations } from '../../services/Ebootis.Queries/AvailableConfigurations';
import { ConfigurationService } from './configuration.service';

@Component({
	selector: 'app-configuration-select',
	templateUrl: './configuration-select.component.html',
	styleUrls: ['./configuration-select.component.scss'],
})
export class ConfigurationSelectComponent implements OnInit, OnDestroy {

	private m_subscriptionsSubject = new Subject();
	public m_configurationResponse: AvailableConfigurations.Result[] = [];

	constructor(
		private m_configurationService: ConfigurationService,
		private translateService: TranslateService,
		private m_router: Router,
		private storageService: StorageService
	) { }

	/**
	 * Liste der vorhandene Konfigurationen werden geladen.
	 */
	public ngOnInit(): void {
		this.m_configurationService.getConfigurations().pipe(
			takeUntil(this.m_subscriptionsSubject),
		).subscribe({
			next: (res) => {
				this.m_configurationResponse = res;
			},
			error: (err) => {
				console.log(err);
			}
		});
	}

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Die OID der ausgewählten Konfiguration wird im ConfigrurationService gespeichert. Es wird auf die Übersicht gewechselt.
	 * @param p_oid OID der ausgewählten Konfiguration
	 */
	public setConfiguration_Click(p_oid: string): void {
		this.m_configurationService.setConfiguration(p_oid);
		this.storageService.clear('session');
		this.translateService.reloadLang(this.translateService.currentLang)
			.subscribe({
				next: () => {
					this.m_router.navigate(['./uebersicht']);
				}
			})
	}

}
